import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const usePlaylistTagOptions = () => {
  const {
    data: playlistTagOptions,
    isLoading: isPlaylistTagOptionsLoading,
    refetch: refetchPlaylistTagOptions,
  } = useQuery({
    queryKey: ["playlistTagOptions"],
    queryFn: () => dropdownService.getPlaylistTagOptions(),
  });

  return {
    playlistTagOptions: playlistTagOptions || [],
    isPlaylistTagOptionsLoading,
    refetchPlaylistTagOptions,
  };
};
